import React, { useState } from 'react';
import { Check } from 'lucide-react';
import SearchSelect from './SearchSelect';
import { BOARD_TYPES, CONDITIONS } from './constants';

export default function BoardForm({ initial, onSave, onCancel, brands, lengths, volumes, fins, onAddBrand }) {
  const [form, setForm] = useState(initial || {
    name: '', board_type: '', length: '', volume: '', fins: '', brand: '', condition: 'Good', notes: '',
  });

  return (
    <div className="space-y-3" data-testid="board-form">
      <input data-testid="board-name-input" type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="board name (e.g. The Daily Driver)" className="w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-xs outline-none focus:border-primary/50 placeholder:text-muted-foreground/40" required />
      <div className="grid grid-cols-2 gap-2">
        <select data-testid="board-type-select" value={form.board_type} onChange={e => setForm({ ...form, board_type: e.target.value })} className="bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-xs outline-none focus:border-primary/50">
          <option value="">type</option>
          {BOARD_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
        <SearchSelect
          testId="board-length-select"
          value={form.length}
          onChange={v => setForm({ ...form, length: v })}
          options={lengths}
          placeholder={'length (e.g. 6\'2")'}
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <SearchSelect
          testId="board-volume-select"
          value={form.volume}
          onChange={v => setForm({ ...form, volume: v })}
          options={volumes}
          placeholder="volume (e.g. 32.0L)"
        />
        <SearchSelect
          testId="board-fins-select"
          value={form.fins}
          onChange={v => setForm({ ...form, fins: v })}
          options={fins}
          placeholder="fin setup"
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <SearchSelect
          testId="board-brand-select"
          value={form.brand}
          onChange={v => setForm({ ...form, brand: v })}
          options={brands}
          placeholder="brand / shaper"
          onAdd={onAddBrand}
          addLabel="Add brand"
        />
        <select data-testid="board-condition-select" value={form.condition} onChange={e => setForm({ ...form, condition: e.target.value })} className="bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-xs outline-none focus:border-primary/50">
          {CONDITIONS.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <input data-testid="board-notes-input" type="text" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} placeholder="notes..." className="w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-xs outline-none focus:border-primary/50 placeholder:text-muted-foreground/40" />
      <div className="flex gap-2">
        <button data-testid="board-save-btn" type="button" onClick={() => onSave(form)} className="flex-1 bg-primary text-primary-foreground text-xs font-bold py-2.5 rounded-xl hover:opacity-90 transition-opacity inline-flex items-center justify-center gap-1">
          <Check className="w-3 h-3" /> Save
        </button>
        <button data-testid="board-cancel-btn" type="button" onClick={onCancel} className="px-4 bg-white/5 border border-white/10 text-muted-foreground text-xs py-2.5 rounded-xl hover:border-white/20 transition-colors">
          Cancel
        </button>
      </div>
    </div>
  );
}
